import React from 'react';

export default function ResponsiveImage({
  srcBase,
  alt,
  className = '',
  fallbackExt = 'png', // photos (e.g. blog covers) ship a .jpg fallback instead
  ...props
}) {
  return (
    <picture>
      <source type="image/avif" srcSet={`${srcBase}.avif`} />
      <source type="image/webp" srcSet={`${srcBase}.webp`} />
      <img src={`${srcBase}.${fallbackExt}`} alt={alt} className={className} {...props} />
    </picture>
  );
}
